import { Separator } from "@/core/components/ui/separator";
import { cn } from "@/core/utils/utils";

interface SidebarSeparatorProps {
  className?: string;
}

export const SidebarSeparator = ({ className }: SidebarSeparatorProps) => (
  <Separator
    orientation="horizontal"
    className={cn("ml-6 w-[388px]", className)}
  />
);
